import styled from 'styled-components';
import {
  colorClear,
  colorPrimary,
  colorGrayDarker,
  colorGrayLightest,
  DEFAULT_SIZE,
  breakpointTablet,
  boxShadow,
  fontFamilyText,
} from 'components/GlobalStyles/variables';
import { AlertWrapper } from 'components/Alert/Alert.styled';

export const ContactStyled = styled.section`
  position: relative;
  background-color: ${colorClear};

  .container-detail {
    background-color: ${colorPrimary};
    height: 3px;
    width: 50px;
    margin: 30px auto 6px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  min-height: 100vh;
`;

export const Container = styled.div`
  position: relative;
  padding: ${DEFAULT_SIZE * 2}px;
  max-width: 630px;

  p.info {
    font-family: ${fontFamilyText};
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    color: ${colorGrayDarker};
    margin: 0 0 36px;
  }

  form {
    margin-bottom: 100px;
  }

  ${AlertWrapper} {
    position: fixed;
    bottom: 30px;
    right: 30px;
  }

  .recaptchaWrapper {
    margin-top: 16px;
  }

  button {
    margin-top: 50px;
    @media (max-width: ${breakpointTablet}px) {
      margin: 39px auto 0;
    }
  }
`;

export const Layer = styled.div`
  position: relative;
`;

export const ConclusionBox = styled.div`
  background: ${colorClear};
  max-width: 460px;
  border: 1px solid ${colorGrayLightest};
  border-radius: 8px;
  padding: 32px 16px;
  margin: 90px auto 0;
  text-align: center;
  box-shadow: ${boxShadow};

  .icon {
    font-size: 74px;
    color: ${colorPrimary};
  }

  p {
    color: ${colorGrayDarker};
    font-size: 14px;
    line-height: 20px;

    &.bold {
      font-weight: bold;
      font-size: 16px;
      line-height: 24px;
    }
  }
`;
